export default "__VITE_ASSET__e78f983a__"